import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, EventEmitter, inject, Inject, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrnDialogRef, provideBrnDialogDefaultOptions } from 'libs/dialog/brain';
import { HlmDialogFooterComponent, HlmDialogHeaderComponent, HlmDialogTitleDirective } from 'libs/dialog/helm';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-test-environment-confirmation',
    templateUrl: './test-environment-confirmation.component.html',
    styleUrls: ['./test-environment-confirmation.component.css'],
    imports: [HlmDialogHeaderComponent, HlmDialogFooterComponent, HlmDialogTitleDirective, FormsModule],
})
export class TestEnvironmentConfirmationComponent {
  savePreference: boolean = false;
  @Output() savePreferenceChange = new EventEmitter<boolean>();

private readonly _dialogRef = inject<BrnDialogRef<boolean>>(BrnDialogRef);

  constructor(

  ) {
  }

  onYesClick(): void {
    // this.dialogRef.close(this.savePreference);
 this._dialogRef.close(this.savePreference);
  }
}
